import React, { useEffect, useState, useRef } from "react";
import { Button, ButtonCol, Form, Modal, Row, Col, Spinner, In } from "react-bootstrap";

const CollectPaymentModal = ({ show, onHide, onCompletePayment, orderSummary, bookingId }) => {


  const [items, setItems] = useState([]);

  const handleCollectedChange = (index, name, value) => {
    if (items.length <= index) {
      // If the index is greater than the length of the items array,
      // create a new element with the specified properties and add it.
      const newItem = {
        collected: 0,
        discount: 0,
        mode: "Cash",
        modeRemaining: "Cash",
        status: "Paid",
        [name]: value
      };
      setItems([...items, newItem]);
    } else {
      // If the index is within the range of the items array,
      // update the specific item's property (name) with the new value.
      const updatedItem = { ...items[index], [name]: value };
      const updatedItems = [...items];
      updatedItems[index] = updatedItem;
      setItems(updatedItems);
    }
  };

  return (
    <Modal size="xl" show={show} onHide={onHide} backdrop={"static"}>
      <Modal.Header>
        <Modal.Title style={{ fontWeight: "bold" }}>Collect Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Col>
          <Row
            style={{
              justifyContent: "space-between"
            }}
          >
            {" "}
            <h5 className="fs-2 fw-bold mb-2 mt-1">Collected Payment?</h5>
            <Form>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control type="Number" placeholder="" value={orderSummary?.grossTotalUnpaid} />
              </Form.Group>
            </Form>
          </Row>
        </Col>

        <Col>
          <Row
            style={{
              justifyContent: "space-between"
            }}
          >
            {" "}
            <h5 className="fs-2 fw-bold mb-2 mt-1">Reference ID</h5>
            <Form>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Control type="text" placeholder="" value={bookingId} />
              </Form.Group>
            </Form>
          </Row>
        </Col>
        <Row>
          <Col>
            <table className="table">
              <thead>
                <tr>
                  <th colSpan="5" className="large-product">
                    Product
                  </th>
                  <th colSpan="1">Qty</th>
                  <th colSpan="1">Price</th>
                  <th colSpan="1">Discount</th>
                  <th colSpan="1">Total</th>
                  <th colSpan="1">Collected</th>
                  <th colSpan="1">Mode</th>
                  <th colSpan="1">Status</th>
                </tr>
              </thead>
              <tbody>
                {orderSummary?.unpaidProducts?.map((product, index) => (
                  <tr>
                    <td colSpan="5" className="large-product">
                      <p>{product.slug}</p>
                    </td>
                    <td colSpan="1">
                      <p>{product.qty}</p>
                    </td>
                    <td colSpan="1">
                      <p>$ {product.unitPrice}</p>
                    </td>
                    <td colSpan="1">
                      <Form.Control
                        type="Number"
                        placeholder="$ 0"
                        name="discount"
                        style={{
                          width: "80px"
                        }}
                        onChange={e => {
                          handleCollectedChange(index, e.target.name, e.target.value);
                        }}
                      />
                    </td>
                    <td colSpan="1">
                      <Col>
                        <p>$ {product.qty * product?.unitPrice}</p>
                        <p
                          style={{
                            color: "gray",
                            marginTop: "10px"
                          }}
                        >
                          Remaining
                        </p>
                      </Col>
                    </td>
                    <td colSpan="1">
                      <Col>
                        <Form.Control
                          type="text"
                          placeholder="$ 0"
                          name="collected"
                          style={{
                            width: "80px"
                          }}
                          onChange={e => {
                            handleCollectedChange(index, e.target.name, e.target.value);
                          }}
                        />
                        <Form.Control
                          type="text"
                          placeholder="$ 1000"
                          name="remaining"
                          style={{
                            width: "80px",
                            marginTop: "10px"
                          }}
                          value={
                            product.qty * product?.unitPrice - items[index]?.collected - items[index]?.discount
                              ? product.qty * product?.unitPrice - items[index]?.collected - items[index]?.discount
                              : product.qty * product?.unitPrice
                          }
                        />
                      </Col>
                    </td>
                    <td colSpan="1">
                      <Col>
                        <Form.Control
                          as="select"
                          style={{
                            width: "100px"
                          }}
                          name="mode"
                          onChange={e => {
                            handleCollectedChange(index, e.target.name, e.target.value);
                          }}
                        >
                          <option>Cash</option>
                          <option>Online</option>
                        </Form.Control>

                        <Form.Control
                          as="select"
                          style={{
                            width: "100px",
                            marginTop: "10px"
                          }}
                          name="modeRemaining"
                          onChange={e => {
                            handleCollectedChange(index, e.target.name, e.target.value);
                          }}
                        >
                          <option>Cash</option>
                          <option>Online</option>
                        </Form.Control>
                      </Col>
                    </td>
                    <td colSpan="1">
                      <Form.Control
                        as="select"
                        style={{
                          width: "100px"
                        }}
                        name="status"
                        onChange={e => {
                          handleCollectedChange(index, e.target.name, e.target.value);
                        }}
                      >
                        <option>Paid</option>
                        <option>Un-Paid</option>
                        {/* Add more options as needed */}
                      </Form.Control>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onCompletePayment}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CollectPaymentModal;
